// extracted by mini-css-extract-plugin
export var container = "_aj-0";